import { render, staticRenderFns } from "./sub-pages.vue?vue&type=template&id=6ac3bf02&scoped=true"
import script from "./sub-pages.vue?vue&type=script&lang=js"
export * from "./sub-pages.vue?vue&type=script&lang=js"
import style0 from "./sub-pages.vue?vue&type=style&index=0&id=6ac3bf02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac3bf02",
  null
  
)

export default component.exports